import * as React from 'react'
import { ActivityGroupDTORead, StatisticGroupDTORead } from '../../models/ActivityDTO'
import { Context } from '../../context/appContext';
import { ActivityGroupRequest } from '../../context/service.activititesgroup';
import { endpoints } from '../../context/endpoints';
import { Button, Card, FormControl, Table } from 'react-bootstrap';
import { ActionButtons, EditButton, RemoveButton } from '../_shared/actionButtons';
import { InputText } from '../_shared/InputText';
import { StatisticGroupRequest } from '../../context/service.statisticgroup';


export function StatisticGroupFrom() {
    const [data, setData] = React.useState<StatisticGroupDTORead[]>([]);
    const { requestToken } = React.useContext(Context);
    const [input, setInput] = React.useState<string>('');

    let apiService: StatisticGroupRequest;

    React.useEffect(() => {
        initService()
    }, [])

    // init service
    const initService = async () => {
        let token = (await requestToken()).accessToken
        apiService = new StatisticGroupRequest(endpoints.statisticgroup, token);

        // group
        let groups = await apiService.getAll();
        setData(groups)
    }

    const add = async () => {
        if(input == '') return;

        let token = (await requestToken()).accessToken
        apiService = new StatisticGroupRequest(endpoints.statisticgroup, token);

        apiService.add({
            GroupName: input
            
        } as StatisticGroupDTORead)
            .then(r => {
                if (r.Success) {
                    initService();
                }
                else {
                    alert(r.ErrorMsg)
                }
            })
            .finally(() => setInput(''))
    }


    return (
        <Card>
            <Card.Body>
                <h3>Statistik Gruppen</h3>

                <div className='mb-3 d-flex'>
                    <FormControl type='text' value={input} onChange={(e) => setInput(e.currentTarget.value)} />
                    <Button onClick={() => add()}>Add</Button>
                </div>

                <table className='table table-sm table-bordered'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((x, i) => {
                            return (
                                <tr key={i}>
                                    <td>{x.Id}</td>
                                    <td>{x.GroupName}</td>
                                    <td>
                                        <ActionButtons>
                                            <EditButton onClick={() => alert('')} />
                                            <RemoveButton onClick={() => alert('')} />
                                        </ActionButtons>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    )
}